import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const NewsRoutes: RouteRecordRaw = {
  path: '/news',
  name: 'NewsModulePages',
  redirect: { name: 'ManageAnnouncementsRoute' },
  children: [
    {
      path: '',
      name: 'ManageAnnouncementsRoute',
      component: () => import('./views/ManageAnnouncementsView.vue'),
      meta: {
        title: 'اطلاعیه‌ها',
      },
    },
    {
      path: 'create',
      name: 'CreateAnnouncementRoute',
      component: () => import('./views/CreateAnnouncementView.vue'),
      meta: {
        title: 'ایجاد اطلاعیه',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.notificationCreate],
      },
    },
    {
      path: ':id/edit',
      name: 'EditAnnouncementRoute',
      component: () => import('./views/EditAnnouncementView.vue'),
      meta: {
        title: 'ویرایش اطلاعیه',
        pageHasBack: true,
        requiredPermissions: [...MODULE_PERMISSIONS.notificationUpdate],
      },
    },
    {
      path: ':id/recipients',
      name: 'AnnouncementRecipientsRoute',
      component: () => import('./views/AnnouncementRecipientsView.vue'),
      meta: {
        title: 'وضعیت دریافت کننده‌ها',
        pageHasBack: true,
      },
    },
    {
      path: ':id',
      name: 'AnnouncementDetailRoute',
      component: () => import('./views/AnnouncementDetailView.vue'),
      meta: {
        title: 'نمایش اطلاعیه',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.news],
  },
}

export default (router: Router) => {
  router.addRoute(NewsRoutes)
}
